export async function GenerateBinderFile({ data, returnBlob = false }) {
  const { title, description, template, metadataPlacement, documents } = data;

  const docsWithBase64 = await Promise.all(
    documents.map(async (doc) => {
      const base64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(doc.file);
      });

      return {
        name: doc.file.name,
        type: doc.file.type,
        base64,
        metadata: doc.metadata || {}
      };
    })
  );

  const fullProjectData = {
    title,
    description,
    template,
    metadataPlacement,
    documents: docsWithBase64
  };

  const blob = new Blob([JSON.stringify(fullProjectData, null, 2)], {
    type: 'application/json'
  });

  if (returnBlob){
    return blob;
  }

  const url = URL.createObjectURL(blob);  
  const a = document.createElement('a');
  a.href = url;
  a.download = `${title || 'project'}.binder`;
  a.click();
  URL.revokeObjectURL(url);
}
